import { Tag } from "@/components/elements/Tag";
import { black, blue, lightBlue, orange } from "@/theme/colors";
import { FCC } from "@/types/common";
import { NOTIFICATION_TYPE, NOTIFICATION_TYPE_LABEL, TNotificationType } from "@/features/dashboard/constants/notificationTab";

type CaseStatusStyle = {
  background: string;
  title: string;
};
type Props = {
  type: TNotificationType;
};

export const NotificationTag: FCC<Props> = ({ type }) => {

  const typeOption: Record<TNotificationType, CaseStatusStyle> = {
    [NOTIFICATION_TYPE.IMPORTANT]: { background: orange[97], title: NOTIFICATION_TYPE_LABEL[NOTIFICATION_TYPE.IMPORTANT] },
    [NOTIFICATION_TYPE.IROHANA]: { background: lightBlue[93], title: NOTIFICATION_TYPE_LABEL[NOTIFICATION_TYPE.IROHANA] },
    [NOTIFICATION_TYPE.SYSTEM]: { background: blue[96], title: NOTIFICATION_TYPE_LABEL[NOTIFICATION_TYPE.SYSTEM] },
  };

  const current = typeOption[type];

  return <Tag color={current.background} textColor={black[30]} title={current.title} fontWeight={400} size="medium" minWidth="102px" />;
};
